import EsSummaryView, {type EsSummaryViewProps} from '@/pages/components/audit-program/e-section/EsSummaryView';
import {MS_PAGE, type MSummaryPage} from '@/pages/components/audit-program/m-section/constants';

export type MsSummaryViewProps = Omit<EsSummaryViewProps, 'page' | 'fallback' | 'refCode'> & {
    page: MSummaryPage;
    refCode?: string;
};

/** Ms — Summary sheet for long-term loans and deferred income. */
export default function MsSummaryView({
    page,
    refCode = 'Ms',
    ...rest
}: MsSummaryViewProps) {
    return <EsSummaryView {...rest} page={page} fallback={MS_PAGE} refCode={refCode}/>;
}
